import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import Layout from './layout/Layout';
import Index from './layout/Index';
import Register from './components/auth/Register';
import LoginUser from './components/auth/LoginUser';
import PrivateRoute from './layout/PrivateRoute';
import PasswordResetRequest from './components/auth/PasswordResetRequest';
import PasswordReset from './components/auth/PasswordReset';
import NewCondition from './components/Conditions/NewCondition';
import Condition from './components/Conditions/Condition';
import EditColumns from './components/Conditions/EditColumns';
import EditRangeQuery from './components/Conditions/EditRangeQuery';
import TestRangeQuery from './components/Conditions/TestRangeQuery';
import Conditions from './components/Conditions/Conditions';
import ManageSubConditions from './components/Conditions/ManageSubConditions';
import SubCondition from './components/Conditions/SubCondition';
import EditChecker from './components/Conditions/EditChecker';
import TestChecker from './components/Conditions/TestChecker';
import CreateRule from './components/Rules/CreateRule';
import CreateAction from './components/Actions/CreateAction';
import CreateChangeDailyBudget from './components/Actions/CreateChangeDailyBudget';
import CreateChangeRoasBidConstraints from './components/Actions/CreateChangeRoasBidConstraints';
import Actions from './components/Actions/Actions';
import Rules from './components/Rules/Rules';
import Rule from './components/Rules/Rule';
import Action from './components/Actions/Action';
import Logs from './components/Logs/Logs';
import CreateChangeStatus from './components/Actions/CreateChangeStatus';
import Log from './components/Logs/Log';
import AccountDashboard from './components/AccountDashboard/AccountDashboard';
import Campaign from './components/AccountDashboard/Campaign';
import ChooseAdAccount from './components/AccountDashboard/ChooseAdAccount';
import AdSet from './components/AccountDashboard/AdSet';
import Ad from './components/AccountDashboard/Ad';
import CreateGeneralSettings from './components/GeneralSettings/CreateGeneralSettings';
import GeneralSettings from './components/GeneralSettings/GeneralSettings';
import GeneralSetting from './components/GeneralSettings/GeneralSetting';
import CreateDuplicateCampaign from './components/Actions/CreateDuplicateCampaign';
import EditDuplicateCampaign from './components/Actions/EditDuplicateCampaign';
import EditChangeDailyBudget from './components/Actions/EditChangeDailyBudget';
import EditAllTargetingFields from './components/Actions/ObjectFields/EditAllTargetingFields';
import LogsByRuleId from './components/Logs/LogsByRuleId';
import RunRules from './components/Rules/RunRules';
import PendingDuplications from './components/PendingDuplications/PendingDuplications';
import PendingDuplication from './components/PendingDuplications/PendingDuplication';
import CreateIncomingWebhook from './components/IncomingWebhooks/CreateIncomingWebhook';
import IncomingWebhooks from './components/IncomingWebhooks/IncomingWebhooks';
import IncomingWebhook from './components/IncomingWebhooks/IncomingWebhook';
import Creative from './components/AccountDashboard/Creative';
import PendingAds from './components/PendingAds/PendingAds';
import PendingAd from './components/PendingAds/PendingAd';
import CreateChangeBidAmount from './components/Actions/CreateChangeBidAmount';
import EditChangeBidAmount from './components/Actions/EditChangeBidAmount';
import CreateTimeTemplate from './components/TimeTemplates/CreateTimeTemplate';
import TimeTamplates from './components/TimeTemplates/TimeTamplates';
import TimeTemplate from './components/TimeTemplates/TimeTemplate';
import OtpLogin from './components/auth/OtpLogin';
import CreateDuplicateDiffAccount from './components/Actions/CreateDuplicateDiffAccount';
import RuleGroups from './components/RuleGroups/RuleGroups';
import CreateRuleGroup from './components/RuleGroups/CreateRuleGroup';
import RuleGroup from './components/RuleGroups/RuleGroup';
import RetryRules from './components/RetryRules/RetryRules';
import AlternativePagesCron from './components/AlternativePagesCron/AlternativePagesCron';
import GcpBucket from './components/GcpBucket/GcpBucket';
import SqlValues from './components/SqlValues/SqlValues';
import EditChangeRoasBidConstraints from './components/Actions/EditChangeRoasBidConstraints';
//import ExternalApiSwagger from './components/externalApi/ExternalApiSwagger';

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '/login/:redirect',
        element: <OtpLogin />,
      },
      {
        path: '/loginuser/:token',
        element: <LoginUser />,
      },
      {
        path: '/register',
        element: <Register />,
      },
      {
        path: '/passwordResetRequest',
        element: <PasswordResetRequest />,
      },
      {
        path: '/passwordReset/:reset_url',
        element: <PasswordReset />,
      },
      {
        path: '/',
        element: (
          <PrivateRoute>
            <Index />
          </PrivateRoute>
        ),
      },
      {
        path: '/profile',
        element: (
          <PrivateRoute>
            <Index />
          </PrivateRoute>
        ),
      },
      {
        path: '/NewCondition',
        element: (
          <PrivateRoute>
            <NewCondition />
          </PrivateRoute>
        ),
      },
      {
        path: '/conditions',
        element: (
          <PrivateRoute>
            <Conditions />
          </PrivateRoute>
        ),
      },
      {
        path: '/condition/:condition_id',
        element: (
          <PrivateRoute>
            <Condition />
          </PrivateRoute>
        ),
      },
      {
        path: '/editConditionColumns/:condition_id',
        element: (
          <PrivateRoute>
            <EditColumns />
          </PrivateRoute>
        ),
      },
      {
        path: '/editRangeQuery/:condition_id',
        element: (
          <PrivateRoute>
            <EditRangeQuery />
          </PrivateRoute>
        ),
      },
      {
        path: '/testRangeQuery/:condition_id',
        element: (
          <PrivateRoute>
            <TestRangeQuery />
          </PrivateRoute>
        ),
      },
      {
        path: '/manageSubConditions/:condition_id',
        element: (
          <PrivateRoute>
            <ManageSubConditions />
          </PrivateRoute>
        ),
      },
      {
        path: '/subCondition/:condition_id/:sub_condition_id',
        element: (
          <PrivateRoute>
            <SubCondition />
          </PrivateRoute>
        ),
      },
      {
        path: '/editChecker/:condition_id/:sub_condition_id/:checker_id',
        element: (
          <PrivateRoute>
            <EditChecker />
          </PrivateRoute>
        ),
      },
      {
        path: '/testChecker/:condition_id/:sub_condition_id/:checker_id',
        element: (
          <PrivateRoute>
            <TestChecker />
          </PrivateRoute>
        ),
      },
      // Actions
      {
        path: '/Actions',
        element: (
          <PrivateRoute>
            <Actions />
          </PrivateRoute>
        ),
      },
      {
        path: '/Action/:action_id',
        element: (
          <PrivateRoute>
            <Action />
          </PrivateRoute>
        ),
      },
      {
        path: '/DuplicateCampaignAction/:action_id',
        element: (
          <PrivateRoute>
            <EditDuplicateCampaign />
          </PrivateRoute>
        ),
      },
      // EditChangeDailyBudget
      {
        path: '/EditChangeDailyBudget/:action_id',
        element: (
          <PrivateRoute>
            <EditChangeDailyBudget />
          </PrivateRoute>
        ),
      },
      {
        path: '/EditChangeBidAmount/:action_id',
        element: (
          <PrivateRoute>
            <EditChangeBidAmount />
          </PrivateRoute>
        ),
      },
      {
        path: '/EditChangeRoasBidConstraints/:action_id',
        element: (
          <PrivateRoute>
            <EditChangeRoasBidConstraints />
          </PrivateRoute>
        ),
      },
      {
        path: '/EditAllTargetingFields/:object_field/:field_name/:action_id',
        element: (
          <PrivateRoute>
            <EditAllTargetingFields />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateAction',
        element: (
          <PrivateRoute>
            <CreateAction />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateChangeDailyBudget',
        element: (
          <PrivateRoute>
            <CreateChangeDailyBudget />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateChangeBidAmount',
        element: (
          <PrivateRoute>
            <CreateChangeBidAmount />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateChangeRoasBidConstraints',
        element: (
          <PrivateRoute>
            <CreateChangeRoasBidConstraints />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateChangeStatus',
        element: (
          <PrivateRoute>
            <CreateChangeStatus />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateDuplicateCampaign',
        element: (
          <PrivateRoute>
            <CreateDuplicateCampaign />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateDuplicateDiffAccount',
        element: (
          <PrivateRoute>
            <CreateDuplicateDiffAccount />
          </PrivateRoute>
        ),
      },
      // Rules
      {
        path: '/rules',
        element: (
          <PrivateRoute>
            <Rules />
          </PrivateRoute>
        ),
      },
      {
        path: '/RunRules',
        element: (
          <PrivateRoute>
            <RunRules />
          </PrivateRoute>
        ),
      },
      {
        path: '/RunRuleById/:rule_id',
        element: (
          <PrivateRoute>
            <RunRules />
          </PrivateRoute>
        ),
      },
      {
        path: '/rule/:rule_id',
        element: (
          <PrivateRoute>
            <Rule />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateRule',
        element: (
          <PrivateRoute>
            <CreateRule />
          </PrivateRoute>
        ),
      },
      // Logs
      {
        path: '/logs',
        element: (
          <PrivateRoute>
            <Logs />
          </PrivateRoute>
        ),
      },
      {
        path: '/logsByRuleId/:rule_id',
        element: (
          <PrivateRoute>
            <LogsByRuleId />
          </PrivateRoute>
        ),
      },
      {
        path: '/log/:log_id',
        element: (
          <PrivateRoute>
            <Log />
          </PrivateRoute>
        ),
      },
      // Pending Ads
      {
        path: '/PendingAds',
        element: (
          <PrivateRoute>
            <PendingAds />
          </PrivateRoute>
        ),
      },
      {
        path: '/PendingAd/:pending_id',
        element: (
          <PrivateRoute>
            <PendingAd />
          </PrivateRoute>
        ),
      },
      // Pending Duplications
      {
        path: '/PendingDuplications',
        element: (
          <PrivateRoute>
            <PendingDuplications />
          </PrivateRoute>
        ),
      },
      {
        path: '/PendingDuplication/:pending_id',
        element: (
          <PrivateRoute>
            <PendingDuplication />
          </PrivateRoute>
        ),
      },
      // Account Dashboard
      {
        path: '/chooseAdAccount',
        element: (
          <PrivateRoute>
            <ChooseAdAccount />
          </PrivateRoute>
        ),
      },
      {
        path: '/accountDashboard/:account_id',
        element: (
          <PrivateRoute>
            <AccountDashboard />
          </PrivateRoute>
        ),
      },
      {
        path: '/campaign/:account_id/:campaign_id',
        element: (
          <PrivateRoute>
            <Campaign />
          </PrivateRoute>
        ),
      },
      {
        path: '/adset/:account_id/:adset_id',
        element: (
          <PrivateRoute>
            <AdSet />
          </PrivateRoute>
        ),
      },
      {
        path: '/ad/:account_id/:ad_id',
        element: (
          <PrivateRoute>
            <Ad />
          </PrivateRoute>
        ),
      },
      {
        path: '/creative/:account_id/:creative_id',
        element: (
          <PrivateRoute>
            <Creative />
          </PrivateRoute>
        ),
      },
      // General Settings
      {
        path: '/CreateGeneralSettings',
        element: (
          <PrivateRoute>
            <CreateGeneralSettings />
          </PrivateRoute>
        ),
      },
      {
        path: '/GeneralSettings',
        element: (
          <PrivateRoute>
            <GeneralSettings />
          </PrivateRoute>
        ),
      },
      {
        path: '/GeneralSetting/:generalSetting_id',
        element: (
          <PrivateRoute>
            <GeneralSetting />
          </PrivateRoute>
        ),
      },
      // Incoming Webhooks
      {
        path: '/IncomingWebhooks',
        element: (
          <PrivateRoute>
            <IncomingWebhooks />
          </PrivateRoute>
        ),
      },
      {
        path: '/IncomingWebhook/:webhook_id',
        element: (
          <PrivateRoute>
            <IncomingWebhook />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateIncomingWebhook',
        element: (
          <PrivateRoute>
            <CreateIncomingWebhook />
          </PrivateRoute>
        ),
      },

      // Time Templates
      {
        path: '/CreateTimeTemplate',
        element: (
          <PrivateRoute>
            <CreateTimeTemplate />
          </PrivateRoute>
        ),
      },
      {
        path: '/timeTemplates',
        element: (
          <PrivateRoute>
            <TimeTamplates />
          </PrivateRoute>
        ),
      },
      {
        path: '/TimeTemplate/:time_template_id',
        element: (
          <PrivateRoute>
            <TimeTemplate />
          </PrivateRoute>
        ),
      },
      // Rule Groups
      {
        path: '/ruleGroups/',
        element: (
          <PrivateRoute>
            <RuleGroups />
          </PrivateRoute>
        ),
      },
      {
        path: '/CreateRuleGroup/',
        element: (
          <PrivateRoute>
            <CreateRuleGroup />
          </PrivateRoute>
        ),
      },
      {
        path: '/RuleGroup/:rule_group_id',
        element: (
          <PrivateRoute>
            <RuleGroup />
          </PrivateRoute>
        ),
      },
      // RetryRules
      {
        path: '/RetryRules',
        element: (
          <PrivateRoute>
            <RetryRules />
          </PrivateRoute>
        ),
      },
      // Alternative Pages Cron Tester
      {
        path: '/AlternativePagesCron',
        element: (
          <PrivateRoute>
            <AlternativePagesCron />
          </PrivateRoute>
        ),
      },

      // GcpBucket
      {
        path: '/GcpBucket',
        element: (
          <PrivateRoute>
            <GcpBucket />
          </PrivateRoute>
        ),
      },

      // Sql Values
      {
        path: '/sqlValues',
        element: (
          <PrivateRoute>
            <SqlValues />
          </PrivateRoute>
        ),
      },

      // External API Swagger
      // {
      //   path: '/external-api',
      //   element: (
      //     <PrivateRoute>
      //       <ExternalApiSwagger />
      //     </PrivateRoute>
      //   ),
      // },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  </Provider>,
);
